import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'SalesDecoration',
  components: {
    MdmStripe
  },
  props: {
    price: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    currentLocale: 'i18n/locale'
  }), {
    percentage() {
      const percentages = [{
        range: {
          min: 0,
          max: 40
        },
        display: 30,
        background: '#50A592'
      }, {
        range: {
          min: 40,
          max: 50
        },
        display: 40,
        background: '#F3BA44'
      }, {
        range: {
          min: 50,
          max: 70
        },
        display: 50,
        background: '#E16E5E'
      }, {
        range: {
          min: 70,
          max: 100
        },
        display: 70,
        background: '#804E8D'
      }];
      const percentage = Math.floor((this.price.amount - this.price.sales_amount) / this.price.amount * 100);
      const result = percentages.find(entry => percentage >= entry.range.min && percentage < entry.range.max);
      return {
        text: this.$t('percentage', {
          x: percentage - percentage % 5
        }),
        color: result.background
      };
    }

  })
};